import { Location } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileWithContentUpload, NazioneItem, OrganizationItem, OrganizationOperatorUpdateItem, OrganizationUpdateItem, ProvinciaItem, UserOrgItem } from 'src/app/models/dataModels';
import { APIService } from 'src/app/services/APIService';
import { AuctionService } from 'src/app/services/auction.service';
import { CommonService } from 'src/app/services/common.service';
import { ConstantsModule } from 'src/app/services/constants.module';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { MessagesService } from 'src/app/services/messages.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { PopupComponent } from '../popup/popup.component';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-anagrafica-azienda',
    templateUrl: './anagrafica-azienda.component.html',
    styleUrls: ['./anagrafica-azienda.component.css'],
    standalone: false
})
export class AnagraficaAziendaComponent extends APIService implements OnInit, OnDestroy {

  constructor(localUtil: LocalUtilService,
    public auctionService: AuctionService,
    private modalService: NgbModal,
    private messageService: MessagesService,
    location: Location, 
    router: Router,
    private route: ActivatedRoute,
    public commonService: CommonService,
    public organizationService: OrganizationService,
    translateService: TranslateService) {
    super(localUtil, location, router, translateService);
    console.log('AnagraficaAziendaComponent()');
  }

  @Input() anagAzienda: OrganizationItem;
  @Input() anagUserAzienda: UserOrgItem;
  nation_list: NazioneItem[] = [];
  province_list: ProvinciaItem[] = [];
  @Input() showCoripetButtons: boolean = true;

  userForm: UntypedFormGroup;
  organizationForm: UntypedFormGroup;

  rappresentanteLegale: FileWithContentUpload;
  flagRappresentanteLegale: boolean;

  visuraCamerale: FileWithContentUpload;
  flagVisuraCamerale: boolean;

  fidejussioneBancaria: FileWithContentUpload;
  flagFidejussioneBancaria: boolean;

  dichiarazione231_2001: FileWithContentUpload;
  flagDichiarazione231_2001: boolean;

  submittedUser: boolean = false;
  submittedOrganization: boolean = false;
  private subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.loadNazioni();
    this.loadProvince();
    this.initializeForms();
  }

  reloadBeans() {
    let user = JSON.parse(sessionStorage.getItem('user'));
    this.anagAzienda = user.organization_detail;
    this.anagUserAzienda = user.user_detail;
  }

  loadNazioni() {
    const nazioniList = this.commonService.getNationsList().subscribe(
        data => {
          let nazioneVuota = new NazioneItem();
          nazioneVuota.codice="";
          nazioneVuota.descrizione=" - ";          
          this.nation_list.push(nazioneVuota);
          this.nation_list.push.apply(this.nation_list, data.list);
      },
        this.handleError(true)
      );
    this.subscriptions.push(nazioniList);
  }

  loadProvince() {
    this.province_list = [];
    const provinceList = this.commonService.getProvinceItalianeList().subscribe(
        data => {
          let provinciaVuota = new ProvinciaItem();
          provinciaVuota.codice=" - ";
          provinciaVuota.descrizione=" - ";          
          this.province_list.push(provinciaVuota);
          this.province_list.push.apply(this.province_list, data.list);
      },
        this.handleError(true)
      );
      this.subscriptions.push(provinceList);
    }

    initializeForms() {
      if (!this.anagUserAzienda || !this.anagAzienda) {
        console.error('anagUserAzienda or anagAzienda is undefined');
        return;
      }
      
      this.userForm = new UntypedFormGroup({
        id: new UntypedFormControl(this.anagUserAzienda.id, []),
        cognome: new UntypedFormControl(this.anagUserAzienda.cognome, [Validators.required]),
        nome: new UntypedFormControl(this.anagUserAzienda.nome, [Validators.required]),
        dateRegistrazione: new UntypedFormControl(this.anagUserAzienda.dateRegistrazione, []),
        email: new UntypedFormControl(this.anagUserAzienda.email, [Validators.required]),
        idOrganization: new UntypedFormControl(this.anagUserAzienda.idOrganization, []),
        lingua: new UntypedFormControl(this.anagUserAzienda.lingua, []),
        mobile: new UntypedFormControl(this.anagUserAzienda.mobile, [Validators.required]),
        telefono: new UntypedFormControl(this.anagUserAzienda.telefono, [Validators.required]),
        ruolo: new UntypedFormControl(this.anagUserAzienda.ruolo, []),
      });

      if (this.anagAzienda.nationality == undefined || this.anagAzienda.nationality == '') {
        this.anagAzienda.nationality = this.anagAzienda.orgname.substr(0, 2);
      }

      if (this.anagAzienda.partitaIva == undefined || this.anagAzienda.partitaIva == '') {
        this.anagAzienda.partitaIva = this.anagAzienda.orgname.substr(3);
      }

      this.organizationForm = new UntypedFormGroup({
        id: new UntypedFormControl(this.anagAzienda.id, [Validators.required]),
        userId: new UntypedFormControl(this.anagAzienda.userId, [Validators.required]),
        orgname: new UntypedFormControl(this.anagAzienda.orgname, [Validators.required]),
        codiceFiscale: new UntypedFormControl(this.anagAzienda.codiceFiscale, [Validators.required]),
        ragioneSociale: new UntypedFormControl(this.anagAzienda.ragioneSociale, [Validators.required]),
        nationality: new UntypedFormControl(this.anagAzienda.nationality, [Validators.required]),
        partitaIva: new UntypedFormControl(this.anagAzienda.partitaIva, [Validators.required]),
        province: new UntypedFormControl(this.anagAzienda.province, [Validators.required]),
        zip: new UntypedFormControl(this.anagAzienda.zip, [Validators.required]),
        city: new UntypedFormControl(this.anagAzienda.city, [Validators.required]),
        indirizzo: new UntypedFormControl(this.anagAzienda.indirizzo, [Validators.required]),
        phone: new UntypedFormControl(this.anagAzienda.phone, [Validators.required]),
        fax: new UntypedFormControl(this.anagAzienda.fax, [Validators.required]),
        pec: new UntypedFormControl(this.anagAzienda.pec, [Validators.required, Validators.email]),
        visuraCamerale: new UntypedFormControl(this.anagAzienda.visuraCamerale, [Validators.required]),
        rappresentanteLegale: new UntypedFormControl(this.anagAzienda.rappresentanteLegale, [Validators.required]),
        fidejussioneBancaria: new UntypedFormControl(this.anagAzienda.fidejussioneBancaria, [Validators.required]),
        dichiarazione231_2001: new UntypedFormControl(this.anagAzienda.dichiarazione231_2001, [Validators.required]),
        totaleFidejussione: new UntypedFormControl(this.anagAzienda.totaleFidejussione, [Validators.required]),
        dataScadenzaFidejussione: new UntypedFormControl(this.anagAzienda.dataScadenzaFidejussione, [Validators.required]),
        capacitaProduttiva: new UntypedFormControl(this.anagAzienda.capacitaProduttiva, []),

        visuraCameraleValidated: new UntypedFormControl(this.anagAzienda.visuraCameraleValidated, []),
        rappresentanteLegaleValidated: new UntypedFormControl(this.anagAzienda.rappresentanteLegaleValidated, []),
        fidejussioneBancariaValidated: new UntypedFormControl(this.anagAzienda.fidejussioneBancariaValidated, []),
        dichiarazione231_2001Validated: new UntypedFormControl(this.anagAzienda.dichiarazione231_2001Validated, []),

        dataCreazione: new UntypedFormControl(this.anagAzienda.dataCreazione, []),
        status: new UntypedFormControl(this.anagAzienda.status, []),
        codiceAzienda: new UntypedFormControl(this.anagAzienda.codiceAzienda, []),
      });
    }

    getRappresentanteLegaleFile(file) {
      if (file != undefined) {
        console.log('getRappresentanteLegaleFile() loaded file: ' + file.name);
      }else {
        console.log('getRappresentanteLegaleFile() unloaded file!');
      }
      this.rappresentanteLegale = new FileWithContentUpload();
      this.rappresentanteLegale.file = file;
      this.organizationForm.get('rappresentanteLegale').reset({ value: '' });
    }

    getVisuraCameraleFile(file) {
      if (file != undefined) {
        console.log('getVisuraCameraleFile() loaded file: ' + file.name);
      }else {
        console.log('getVisuraCameraleFile() unloaded file!');
      }
      this.visuraCamerale = new FileWithContentUpload();
      this.visuraCamerale.file = file;
      this.organizationForm.get('visuraCamerale').reset({ value: '' });
    }

    getFidejussioneBancariaFile(file) {
      if (file != undefined) {
        console.log('getFidejussioneBancariaFile() loaded file: ' + file.name);
      }else {
        console.log('getFidejussioneBancariaFile() unloaded file!');
      }
      this.fidejussioneBancaria = new FileWithContentUpload();
      this.fidejussioneBancaria.file = file;
      this.organizationForm.get('fidejussioneBancaria').reset({ value: '' });
    }

    getDichiarazione231_2001File(file) {
      if (file != undefined) {
        console.log('getDichiarazione231_2001File() loaded file: ' + file.name);
      }else {
        console.log('getDichiarazione231_2001File() unloaded file!');
      }
      this.dichiarazione231_2001 = new FileWithContentUpload();
      this.dichiarazione231_2001.file = file;
      this.organizationForm.get('dichiarazione231_2001').reset({ value: '' });
    }

    checkErrorOrganization(prop: string) {
      if (!this.organizationForm) {
        console.error('organizationForm is undefined');
        return false;
      }
      let output: boolean = !this.organizationForm.get(prop).valid && this.submittedOrganization;
      //console.log('prop: ' + prop  + ' valid: ' + this.plantForm.get(prop).valid + ' output: ' + output);
      return output;
    }

    controlUserHasError(nome) {
      return !this.userForm.get(nome).valid && this.submittedUser;
    }

    controlOrgHasError(nome) {
      return !this.organizationForm.get(nome).valid && this.submittedOrganization;
    }

    validateFieldUser(nome) {
      try {
        return this.userForm.get(nome).valid;
      } catch (err) {
        console.log('error on validateFieldUser(' + nome + ') err: ' + err);
        return true;
      }
    }

    validateFieldOrg(nome) {
      try {
        return this.organizationForm.get(nome).valid;
      } catch (err) {
        console.log('error on validateFieldOrg(' + nome + ') err: ' + err);
        return true;
      }
    }

    saveUser() {
      console.log('saveUser()');
      if (this.validateUser()) {

        console.log('saveUser() form valido');
        let op: OrganizationOperatorUpdateItem = new OrganizationOperatorUpdateItem();
        op = {
          nome: this.userForm.get('nome').value,
          cognome: this.userForm.get('cognome').value,
          email: this.userForm.get('email').value,
          lingua: this.userForm.get('lingua').value,
          telefono: this.userForm.get('telefono').value,
          mobile: this.userForm.get('mobile').value,
        };

        const userService = this.organizationService.updateUser(op).subscribe(
          (res:any) => {
            this.localUtil.showMessage("", ConstantsModule.INFO_TITLE, this.messageService.getLabelFromCode("GENERIC_SUCCESS_MESSAGE_SAVE"), true);
            let authParam = this.localUtil.authParams;
            authParam.user_detail.nome = res.detail.nome;
            authParam.user_detail.cognome = res.detail.cognome;
            authParam.user_detail.email = res.detail.email;
            authParam.user_detail.lingua = res.detail.lingua;
            authParam.user_detail.telefono = res.detail.telefono;
            authParam.user_detail.mobile = res.detail.mobile;
            if (!this.isAdmin() && !this.isCoripet()) {
              this.localUtil.setAuthParams(authParam);
            }
            if (this.localUtil.isUser()) {
              this.reloadBeans();
            }
          },
          this.handleError(true)
        );
        this.subscriptions.push(userService);

      } else {
        this.localUtil.showMessage("", ConstantsModule.ERROR_TITLE, this.messageService.getLabelFromCode("ERROR_FORM_VALIDATION_MESSAGE"), true);
      }
    }

    saveOrganization() {
      console.log('saveOrganization()');
      if (this.validateOrganization()) {

        console.log('saveOrganization() form valido');
        let org: OrganizationUpdateItem = new OrganizationUpdateItem();
        org = {
          nazionalita: this.organizationForm.get('nationality').value,
          ragioneSociale: this.organizationForm.get('ragioneSociale').value,
          provincia: this.organizationForm.get('province').value,
          citta: this.organizationForm.get('city').value,
          cap: this.organizationForm.get('zip').value,
          indirizzo: this.organizationForm.get('indirizzo').value,
          telefono: this.organizationForm.get('phone').value,
          fax: this.organizationForm.get('fax').value,
          pec: this.organizationForm.get('pec').value,
          totaleFidejussione: this.organizationForm.get('totaleFidejussione').value,
          visuraCameraleUuid: this.organizationForm.get('visuraCamerale').value,
          rappresentanteLegaleUuid: this.organizationForm.get('rappresentanteLegale').value,
          fidejussioneBancariaUuid: this.organizationForm.get('fidejussioneBancaria').value,
          dichiarazione231_2001Uuid: this.organizationForm.get('dichiarazione231_2001').value,
          codiceAzienda: this.organizationForm.get('codiceAzienda').value,
        };

        const orgService = this.organizationService.updateOrganization(this.anagAzienda.orgname, org).subscribe(
          (res:any) => {
            this.localUtil.showMessage("", ConstantsModule.INFO_TITLE, this.messageService.getLabelFromCode("GENERIC_SUCCESS_MESSAGE_SAVE"), true);

            let authParam = this.localUtil.authParams;
            authParam.organization_detail.nationality = res.detail.nazionalita;
            authParam.organization_detail.ragioneSociale = res.detail.ragioneSociale;
            authParam.organization_detail.partitalva = res.detail.partitalva;            
            authParam.organization_detail.province = res.detail.provincia;
            authParam.organization_detail.city = res.detail.citta;
            authParam.organization_detail.zip = res.detail.cap;
            authParam.organization_detail.indirizzo = res.detail.indirizzo;
            //console.log('authParam.organization_detail.telefono: ' + authParam.organization_detail.telefono + ' res.detail.telefono: ' + res.detail.telefono);
            authParam.organization_detail.phone = res.detail.telefono;
            authParam.organization_detail.fax = res.detail.fax;
            authParam.organization_detail.pec = res.detail.pec;
            authParam.organization_detail.totaleFidejussione = res.detail.totaleFidejussione;
            authParam.organization_detail.capacitaProduttiva = res.detail.capacitaProduttiva;
            authParam.organization_detail.dataScadenzaFidejussione = res.detail.dataScadenzaFidejussione;
            authParam.organization_detail.fidejussioneBancaria = res.detail.fidejussioneBancaria;
            authParam.organization_detail.fidejussioneBancariaValidated = res.detail.fidejussioneBancariaValidated;
            authParam.organization_detail.visuraCamerale = res.detail.visuraCamerale;
            authParam.organization_detail.visuraCameraleValidated = res.detail.visuraCameraleValidated;
            authParam.organization_detail.rappresentanteLegale = res.detail.rappresentanteLegale;
            authParam.organization_detail.rappresentanteLegaleValidated = res.detail.rappresentanteLegaleValidated;
            authParam.organization_detail.dichiarazione231_2001 = res.detail.dichiarazione231_2001;
            authParam.organization_detail.dichiarazione231_2001Validated = res.detail.dichiarazione231_2001Validated;
            authParam.organization_detail.codiceAzienda = res.detail.codiceAzienda;
            if (!this.isAdmin() && !this.isCoripet()) {
              this.localUtil.setAuthParams(authParam);
            }
            if (this.localUtil.isUser()) {
              this.reloadBeans();
            }
          },
          this.handleError(true)
        );
        this.subscriptions.push(orgService);

      } else {
        this.localUtil.showMessage("", ConstantsModule.ERROR_TITLE, this.messageService.getLabelFromCode("ERROR_FORM_VALIDATION_MESSAGE"), true);
      }
    }

    validateUser() {
      console.log('validateUser()');
      this.submittedUser = true;
      let output = true;
      console.log(this.userForm);
      Object.keys(this.userForm.controls).forEach(key => {
        //console.log(key + ' ' + this.userForm.get(key).value + ' valid?: ' + this.userForm.get(key).valid);
        if (!this.userForm.get(key).valid) {
          output = false;
        }
      });      
      return output;
    }

    validateOrganization() {
      console.log('validateOrganization()');
      this.submittedOrganization = true;
      let output = true;
      console.log(this.organizationForm);
      Object.keys(this.organizationForm.controls).forEach(key => {
        //console.log(key + ' ' + this.organizationForm.get(key).value + ' valid?: ' + this.organizationForm.get(key).valid);
        if (!this.organizationForm.get(key).valid) {
          output = false;
        }
      });      
      return output;
    }

    getVisuraExternalLink(vatnumber: string) {
      //console.log('getVisuraExternalLink()');
      let output = '/' + ConstantsModule.REF_AZ_UPLOAD_VISURA_PATH;
      if (this.isCoripet()) {
        output = ConstantsModule.CORIPET_UPLOAD_VISURA_PATH + vatnumber;
      }
      /*if (vatnumber) {
        output += vatnumber;
      }*/
      //console.log(output);
      return output;
    }

    getLegaleExternalLink(vatnumber: string) {
      //console.log('getLegaleExternalLink()');
      let output = '/' + ConstantsModule.REF_AZ_UPLOAD_LEGALE_PATH;
      if (this.isCoripet()) {
        output = ConstantsModule.CORIPET_UPLOAD_LEGALE_PATH + vatnumber;
      }
      /*if (vatnumber) {
        output += vatnumber;
      }*/
      //console.log(output);
      return output;
    }

    getFideiussioneExternalLink(vatnumber: string) {
      //console.log('getFideiussioneExternalLink()');
      let output = '/' + ConstantsModule.REF_AZ_UPLOAD_FIDEIUSSIONE_PATH;
      if (this.isCoripet()) {
        output = ConstantsModule.CORIPET_AZ_UPLOAD_FIDEIUSSIONE_PATH + vatnumber;
      }
      /*if (vatnumber) {
        output += vatnumber;
      }*/
      //console.log(output);
      return output;
    }

    getDoc231ExternalLink(vatnumber: string) {
      //console.log('getDoc231ExternalLink()');
      let output = '/' + ConstantsModule.REF_AZ_UPLOAD_DOC_231_2001_PATH;
      if (this.isCoripet()) {
        output = ConstantsModule.CORIPET_UPLOAD_DOC_231_2001_PATH + vatnumber;
      }
      /*if (vatnumber) {
        output += vatnumber;
      }*/
      //console.log(output);
      return output;
    }

    approveOrganization() {

      const orgService = this.organizationService.approveOrganization(this.anagAzienda.orgname).subscribe(
        data => {
          
          const modalRef = this.modalService.open(PopupComponent);
          modalRef.componentInstance.titolo = this.messageService.getLabelFromCode("INFO_TITLE");
          modalRef.componentInstance.messaggio = this.messageService.getMessageFromCode("OK_OPERATION");
          modalRef.componentInstance.tipo = 'message';
          modalRef.componentInstance.passEntry.subscribe((receivedEntry:any) => {
            this.reloadComponent();
          });

        }, this.handleError(true));
        this.subscriptions.push(orgService);
    }
  
    rejectOrganization() {
      
      const orgService = this.organizationService.rejectOrganization(this.anagAzienda.orgname).subscribe(
        data => {
          
          const modalRef = this.modalService.open(PopupComponent);
          modalRef.componentInstance.titolo = this.messageService.getLabelFromCode("INFO_TITLE");
          modalRef.componentInstance.messaggio = this.messageService.getMessageFromCode("OK_OPERATION");
          modalRef.componentInstance.tipo = 'message';
          modalRef.componentInstance.passEntry.subscribe((receivedEntry:any) => {
            this.reloadComponent();
          });

        }, this.handleError(true));
        this.subscriptions.push(orgService);

    }

    ngOnDestroy() {
      try {
        this.subscriptions.forEach(sub => {
                  
          sub.unsubscribe()
        });
      } catch (err) {
        //
      }
    }

  }